// @flow
import {GENERIC_EVENT, trigger} from '../../utils/edapWrapper';

import type {Store} from '../../reducers/index';

export default function applyFilterEdapEvents(store: Store): void {
    const {
        params,
        prevParams,
        inputParamsAreDefault
    } = store.getState().searchParams;
    const {minBedrooms, maxBedrooms} = params;
    const {
        minBedrooms: oldMinBedrooms,
        maxBedrooms: oldMaxBedrooms
    } = prevParams;
    const hasBedroomsExactMatchChanged =
        (oldMaxBedrooms === oldMinBedrooms && minBedrooms !== maxBedrooms) ||
        (oldMaxBedrooms !== oldMinBedrooms && minBedrooms === maxBedrooms);
    const eventaction = 'filters applied';

    if (hasBedroomsExactMatchChanged && !inputParamsAreDefault) {
        const eventlabel =
            minBedrooms === maxBedrooms
                ? 'bedrooms_exact'
                : 'bedrooms_no_exact';
        trigger(GENERIC_EVENT, {
            eventaction,
            eventlabel,
            highfrequency: 'true'
        });
    }
}
